import { c as _c } from "react/compiler-runtime";
import { Button } from '@mui/material';

// can remove this component once we move to MUI v6, as there a built in loading prop for the Button component.
export function LoaderButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button className="cursor-default pointer-events-none" variant="outlined"><i className="line-md-loading-loop w-[20px] h-[20px]" /></Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}